// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.singlefamilyenterprise.properties.RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { SingleFamilyEnterprisePropertyCustomerIdRequestDto } from '../..';

export const RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler_customerId_Path =
  '/api/web/v2/users/singleFamilyEnterprise/properties/customerId';

/**
 * Edit single family enterprise contract customerId for a listing
 */
export const RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler_customerId = (
  postData: SingleFamilyEnterprisePropertyCustomerIdRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SingleFamilyEnterprisePropertyCustomerIdRequestDto, void>(
    {
      endpoint: RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler_customerId_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
